import { useEffect, useRef } from"react";

interface UseExitIntentOptions {
 onExitIntent: () => void;
 /** Pixels from top of window that triggers exit intent (default: 10) */
 threshold?: number;
 /** Session storage key to prevent showing more than once (default:"exitIntentShown") */
 storageKey?: string;
}

export const useExitIntent = ({
 onExitIntent,
 threshold = 10,
 storageKey ="exitIntentShown",
}: UseExitIntentOptions) => {
 const firedRef = useRef(false);

 useEffect(() => {
 // Don't show again — ever (persists across sessions)
 if (localStorage.getItem(storageKey)) return;

 const handleMouseLeave = (e: MouseEvent) => {
 if (firedRef.current) return;
 // Trigger when mouse moves towards the top of the viewport
 if (e.clientY <= threshold) {
 firedRef.current = true;
 localStorage.setItem(storageKey,"true");
 onExitIntent();
 }
 };

 // Small delay so we don't fire immediately on page load
 const timer = setTimeout(() => {
 document.addEventListener("mouseleave", handleMouseLeave);
 }, 2000);

 return () => {
 clearTimeout(timer);
 document.removeEventListener("mouseleave", handleMouseLeave);
 };
 }, [onExitIntent, threshold, storageKey]);
};
